<div class="otp-container cbw-otp-container">
  <input 
    type="hidden" 
    autocomplete="one-time-code"
    inputmode="text"
    class="otp-box cbw-otp-box"
  />
  @for (val of otpValues; let idx = $index; track idx) {
    <input
      #otpInput
      [type]="isPassword ? 'password' : 'text'"
      inputmode="text"
      class="otp-box cbw-otp-box"
      [value]="otpValues[idx]"
      (input)="onInput($event, idx)"
      (keydown)="onKeyDown($event, idx)"
      (focus)="onFocus($event, idx)"
      (paste)="onPaste($event)"
      autocomplete="off"
      aria-label="OTP Digit"
      required [ngClass]="{ 'is-invalid': otpInput.touched && otpInput.invalid }" 
    />
  }
</div>